import EventsBlockEventPreview from "./EventsBlockEventPreview";

export default EventsBlockEventPreview;